<template>
    <div class="el-section">
      <section class="el-section">
        <div class="el-chunk">
          <h2 class="emd-text _size_page">{{ $t('welcome') }}</h2>
        </div>
      </section>
      <div class="el-section">
        <div class="emd-spotlight-list" :class="{ '_has-selected': selectedPaymentType }">
          <div class="eu-flex eu-justify_center">
            <div class="eu-flex-item eu-basis_12 eu-basis_6_md eu-mb_3 eu-no-margin_md">
              <div class="emd-spotlight-list__item emd-container _type_card _content_stretch eu-display_flex _actionable eu-pa_4 _selected"
                :class="{ '_active _selected': selectedPaymentType === item.title }"
                @click="selectPaymentType(item.title)">
                <div class="emd-container__header">
                  <span class="emd-text" :class="{ '_color_tertiary': selectedPaymentType === item.title }">
                    <i class="emd-text _size_page" :class="['uil', item.icon]"></i>
                  </span>
                </div>
                <div class="emd-container__content">
                  <p class="emd-text _type_caption eu-pb_1">{{$t(`${item.title}.label`)}}</p>
                  <p class="emd-text">{{$t(`${item.title}.description`)}}</p>
                  <div class="emd-highlight-tag _bottom" :class="{ '_active _color_tertiary': selectedPaymentType === item.title }">
                    <span class="eu-position_relative">
                      <i class="uil uil-check"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ItemsOnly',
  data: function () {
    return {
      item: {
        title: 'items',
        icon: 'uil-shopping-basket'
      }
    }
  },
  computed: {
    ...mapGetters(['selectedPaymentType', 'routesWizard', 'hasSubscriptionEnabled', 'accountSummary']),
    isCheckoutV2Enabled () {
      return this.accountSummary.checkout_v2_enabled
    },
    computedRoutesWizard: {
      get () {
        return this.routesWizard
      },
      set (value) {
        this.SET_ROUTES_WIZARD(value)
      }
    }
  },
  methods: {
    ...mapActions(['SET_PAYMENT_TYPE', 'RESET_PAYMENT_STATE', 'RESET_ORDER_STATE', 'RESET_PERMISSION', 'SET_ROUTES_WIZARD', 'SET_ITEM_PERMISSION']),
    selectPaymentType (value) {
      let paymentType = value
      if (this.isCheckoutV2Enabled && value === 'items') {
        paymentType = 'options'
      }
      this.SET_PAYMENT_TYPE(paymentType)
      this.goToNext(this.selectedPaymentType)
    },
    goToNext (value) {
      this.RESET_PAYMENT_STATE()
      this.RESET_ORDER_STATE()
      this.RESET_PERMISSION('OrderType')
      const routes = this.computedRoutesWizard
      this.computedRoutesWizard = routes.map((item, idx) => {
        if (item.path === value) this.SET_ITEM_PERMISSION({ index: idx, permission: true })
        return item
      })
      this.$router.push({ path: value })
    }
  }
}
</script>

  <i18n>
  {
    "pt-BR": {
      "welcome": "Boas-vindas ao Shop!",
      "header": "O que deseja fazer?",
      "items": {
        "label": "Criar um pedido",
        "description": "Adicione os itens e gere um pedido manual."
      }
    },
    "en-US": {
      "welcome": "Welcome to Shop",
      "header": "What would you like to do?",
      "items": {
        "label": "Create an order",
        "description": "Add the items and make a manual order"
      }
    }
  }
  </i18n>
